import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route
} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './pages/Home';
import Users from './pages/Users';

function App() {
  return (
    <div className="container py-4">
      <header className="pb-3 mb-4 border-bottom">
        <div className="d-flex align-items-center text-dark text-decoration-none">
          <span className="fs-4">Testing example</span>
        </div>
      </header>

      <BrowserRouter>
        <Switch>
          <Route path="/users">
            <Users />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </BrowserRouter>

      <footer className="pt-3 mt-4 text-muted border-top">
        © 2021
      </footer>
    </div>
  );
}

export default App;
